import { ReactNode } from "react";

export function LegalProse({ children }: { children: ReactNode }) {
  return (
    <div className="prose prose-neutral max-w-3xl mt-8 prose-headings:font-display prose-headings:tracking-tight prose-h2:text-xl prose-h2:mt-10 prose-p:text-[hsl(var(--brand-slate))] prose-p:leading-relaxed">
      {children}
    </div>
  );
}
